import { createSlice } from "@reduxjs/toolkit";
import { fetchArchiveServicesTeacherTrainingData,updateMergeDataToActualData } from "../thunks/archiveServicesThunk";

const archiveServicesTeacherTrainingSlice = createSlice({
  name: "archiveServicesTeacherTraining",
  initialState: {
    data: [{
            "regionType": "",
            "regionCode": "",
            "yearId": 11,
            "location": "India",
            
    }],
    isLoading:true,
    isError:false,
    error:null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchArchiveServicesTeacherTrainingData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchArchiveServicesTeacherTrainingData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchArchiveServicesTeacherTrainingData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })

      .addCase(updateMergeDataToActualData.fulfilled, (state, action) => {
        state.data.data = action.payload;
        state.isLoading = false;
      })
  },
});

export default archiveServicesTeacherTrainingSlice.reducer;